import { FaFolder } from "react-icons/fa";
import { HiOutlineCubeTransparent } from "react-icons/hi";
import { AiOutlineLock } from "react-icons/ai";
import "../../styles/visualization/entryCard.css";
import { useNavigate } from "react-router-dom";

const typeIcons = {
  folder: FaFolder,
  visualization: HiOutlineCubeTransparent,
  publication: HiOutlineCubeTransparent,
};

const EntryCard = ({ entry, currentFolderPath }) => {
  const { type, item } = entry;
  const uiType = type === "publication" ? "visualization" : type;
  const Icon = typeIcons[type] || HiOutlineCubeTransparent;
  const navigate = useNavigate();

  const handleClick = () => {
    const pathWithoutRoot = currentFolderPath.slice(1); // remove root
    // 📁 Folder navigation
    if (uiType === "folder") {
      navigate(
        `/f/visualizations/${[...pathWithoutRoot, entry.itemId].join("/")}`,
      );
    }

    // 🎬 Visualization navigation
    else if (uiType === "visualization") {
      navigate(
        `/v/visualizations/${[...pathWithoutRoot, entry.itemId].join("/")}`,
      );
    }
  };

  const isPaid = item?.accessType === "paid";

  return (
    <div className={`folder-entry-card ${isPaid ? "folder-entry-card-paid" : ""}`} onClick={handleClick}>
      <div className="folder-entry-card-header">
        <div className="folder-entry-card-type">{uiType}</div>
        {isPaid && <AiOutlineLock size={13} className="folder-entry-lock" />}
      </div>

      <div className="folder-entry-card-icon">
        <Icon />
      </div>

      <div className="folder-entry-card-title" title={item.title}>
        {item.title}
      </div>

      {item.description && (
        <div className="folder-entry-card-description" title={item.description}>
          {item.description}
        </div>
      )}
    </div>
  );
};

export default EntryCard;
